export const IMAGES_ASPECT_RATIO_LAYOUT_1 = [
  {
    width: 928,
    height: 340,
    aspectRatio: 928 / 340,
  },
  {
    width: 452,
    height: 340,
    aspectRatio: 452 / 340,
  },
  {
    width: 452,
    height: 340,
    aspectRatio: 452 / 340,
  },
  {
    width: 288,
    height: 288,
    aspectRatio: 288 / 288,
  },
  {
    width: 288,
    height: 288,
    aspectRatio: 288 / 288,
  },
  {
    width: 288,
    height: 288,
    aspectRatio: 288 / 288,
  },
];

export const IMAGES_ASPECT_RATIO_LAYOUT_2 = [
  {
    width: 928,
    height: 340,
    aspectRatio: 928 / 340,
  },
  {
    width: 452,
    height: 340,
    aspectRatio: 452 / 340,
  },
  {
    width: 452,
    height: 340,
    aspectRatio: 452 / 340,
  },
];

export const IMAGES_ASPECT_RATIO_LAYOUT_3 = [
  {
    width: 452,
    height: 340,
    aspectRatio: 452 / 340,
  },
  {
    width: 452,
    height: 340,
    aspectRatio: 452 / 340,
  },
];

export function fillArray<T>(arr: T[], idx: number, value: T): T[] {
  arr[idx] = value;
  return arr;
}
